import React, { useEffect, useState } from "react";

export default function Navbar({ onBookClick }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#121212]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_premium-shop-book/artifacts/qj6if298_IMG_7610.PNG"
            alt="Premium Auto Works"
            className="h-12 sm:h-14 w-auto object-contain group-hover:scale-105 transition-transform"
          />
        </a>
        <button
          onClick={onBookClick}
          data-testid="navbar-book-button"
          className="glow-yellow bg-[#F5C518] hover:bg-[#FFD642] text-[#121212] font-display font-bold uppercase text-xs sm:text-sm tracking-wider px-4 sm:px-6 py-2.5 sm:py-3 rounded-full"
        >
          Book Appointment Now
        </button>
      </div>
    </nav>
  );
}
